/* Keeps the PDP Add To Bag price synced with the base product price, selected SellEasy add-ons and checked theme upsells. */
(function () {
  function extractMoneyMatches(text) {
    if (!text) return [];

    return text.match(/[$€£¥₹]\s?\d[\d,]*(?:\.\d{2})?/g) || [];
  }

  function moneyTextToCents(text) {
    var matches = extractMoneyMatches(text);
    var moneyText = matches.length ? matches[matches.length - 1] : text;

    if (!moneyText) return null;

    var normalized = moneyText.replace(/[^\d.]/g, '');
    var amount = parseFloat(normalized);

    if (isNaN(amount)) return null;

    return Math.round(amount * 100);
  }

  function formatCents(cents) {
    if (typeof formatMoney === 'function') {
      return formatMoney(cents, window.theme.settings.money_with_currency_format);
    }

    return '$' + (cents / 100).toFixed(2);
  }

  function getBasePriceCents(priceEl) {
    if (!priceEl || priceEl.classList.contains('visibility-hidden')) {
      return null;
    }

    var selectors = ['ins .amount', '.amount.discounted', '.amount', 'ins'];
    for (var i = 0; i < selectors.length; i += 1) {
      var match = priceEl.querySelector(selectors[i]);
      var cents = match ? moneyTextToCents(match.textContent) : null;

      if (cents !== null) {
        return cents;
      }
    }

    return moneyTextToCents(priceEl.textContent);
  }

  function getSellEasyContainer(scopeRoot) {
    return scopeRoot.querySelector('.lb-list');
  }

  function isSelectedSellEasyCard(card) {
    if (!card) return false;

    if (card.hasAttribute('lb-selected')) {
      return true;
    }

    var input = card.querySelector('.lb-card-checkbox');
    return !!(input && input.checked);
  }

  function getSellEasyCardPriceCents(card) {
    if (!card) return null;

    var salePrice = card.querySelector('.lb-price-sale-price');
    if (salePrice) {
      var rawDefaultPrice = salePrice.getAttribute('lb-default-price');
      if (rawDefaultPrice) {
        var defaultPrice = Number(rawDefaultPrice);
        if (!isNaN(defaultPrice)) {
          return Math.round(defaultPrice);
        }
      }

      var rawPrice = salePrice.getAttribute('lb-price');
      var parsedPrice = moneyTextToCents(rawPrice || salePrice.textContent);
      if (parsedPrice !== null) {
        return parsedPrice;
      }
    }

    return null;
  }

  function getSelectedAddonTotal(scopeRoot) {
    var container = getSellEasyContainer(scopeRoot);
    if (!container) return 0;

    var total = 0;
    var cards = container.querySelectorAll('lb-upsell-flat-card');

    cards.forEach(function (card) {
      if (!isSelectedSellEasyCard(card)) return;

      var cents = getSellEasyCardPriceCents(card);
      if (cents === null) return;

      total += cents;
    });

    return total;
  }

  function getCheckedUpsellTotal(scopeRoot) {
    var total = 0;

    scopeRoot.querySelectorAll('[data-upsell-add].checked').forEach(function (checkbox) {
      var cents = Number(checkbox.getAttribute('data-product-price'));
      if (!isNaN(cents)) {
        total += cents;
      }
    });

    return total;
  }

  function getScopeRoot(sectionId, priceEl) {
    var productInfo = document.getElementById('ProductInfo-' + sectionId);
    if (productInfo) {
      return productInfo.closest('[id^="shopify-section-"]') || productInfo;
    }

    return (priceEl && priceEl.closest('[id^="shopify-section-"]')) || document.body;
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.atc-button-price[data-section]').forEach(function (priceSpan) {
      var sectionId = priceSpan.dataset.section;
      var priceEl = document.getElementById('price-' + sectionId);
      var scopeRoot = getScopeRoot(sectionId, priceEl);

      if (!priceEl) return;

      function sync() {
        var basePrice = getBasePriceCents(priceEl);

        if (basePrice === null) {
          priceSpan.hidden = true;
          return;
        }

        var totalPrice = basePrice + getSelectedAddonTotal(scopeRoot) + getCheckedUpsellTotal(scopeRoot);

        priceSpan.textContent = '| ' + formatCents(totalPrice);
        priceSpan.hidden = false;
      }

      function scheduleSync(event) {
        if (event && event.target && !event.target.closest('.lb-list, .lb-card-checkbox, lb-upsell-flat-card')) {
          return;
        }

        window.requestAnimationFrame(sync);
        window.setTimeout(sync, 60);
        window.setTimeout(sync, 180);
      }

      new MutationObserver(sync).observe(priceEl, {
        childList: true,
        subtree: true,
        characterData: true,
        attributes: true,
        attributeFilter: ['class']
      });

      var sellEasyContainer = getSellEasyContainer(scopeRoot);
      if (sellEasyContainer) {
        new MutationObserver(scheduleSync).observe(sellEasyContainer, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: ['lb-selected', 'class']
        });
      }

      scopeRoot.addEventListener('change', scheduleSync, true);
      scopeRoot.addEventListener('click', scheduleSync, true);
      scopeRoot.addEventListener('input', scheduleSync, true);
      document.addEventListener('product:variant-change', function () {
        window.setTimeout(sync, 0);
      });
      document.addEventListener('upsell:change', sync);

      sync();
    });
  });
})();

/* Hides PostScript back-in-stock bubble on PDPs that do not track inventory. */
(function () {
  var PS_ROOT_ID = 'ps__bis_container_root';
  var psObserver = null;

  function removePostscriptRoot() {
    var root = document.getElementById(PS_ROOT_ID);
    if (!root) return;

    root.remove();
  }

  function startPostscriptGuard() {
    removePostscriptRoot();

    if (psObserver) return;

    psObserver = new MutationObserver(function () {
      removePostscriptRoot();
    });

    psObserver.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  function getCurrentProductHandle() {
    var productRoot = document.querySelector('.thb-product-detail.product[data-handle]');
    if (!productRoot) return null;

    return productRoot.getAttribute('data-handle');
  }

  function hasTrackedInventory(productData) {
    if (!productData || !Array.isArray(productData.variants) || !productData.variants.length) {
      return false;
    }

    return productData.variants.some(function (variant) {
      return !!(variant && variant.inventory_management);
    });
  }

  function runInventoryTrackingCheck() {
    if (!document.body.classList.contains('template-product')) return;

    var handle = getCurrentProductHandle();
    if (!handle) return;

    fetch('/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) return null;
        return response.json();
      })
      .then(function (productData) {
        if (hasTrackedInventory(productData)) return;

        startPostscriptGuard();
      })
      .catch(function () {
        // Fail closed: do nothing when product lookup is unavailable.
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runInventoryTrackingCheck);
  } else {
    runInventoryTrackingCheck();
  }
})();
